// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { useTheme, CircularProgress, Box } from '@mui/material';
// import { Col, Row } from 'react-bootstrap';
// import { GetallStagesWithLeadsCount_For_Admin_Dashboard_Action_CRM_Data } from '../../Redux/Actions/UsersAction';

// // Icons
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import NewReleasesOutlinedIcon from '@mui/icons-material/NewReleasesOutlined';
// import ControlPointDuplicateOutlinedIcon from '@mui/icons-material/ControlPointDuplicateOutlined';
// import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
// import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
// import StarOutlineOutlinedIcon from '@mui/icons-material/StarOutlineOutlined';
// import AccessAlarmOutlinedIcon from '@mui/icons-material/AccessAlarmOutlined';
// import DoNotDisturbOnOutlinedIcon from '@mui/icons-material/DoNotDisturbOnOutlined';
// import Person3OutlinedIcon from '@mui/icons-material/Person3Outlined';
// import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
// import DoDisturbOutlinedIcon from '@mui/icons-material/DoDisturbOutlined';
// import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
// import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
// import EventRepeatOutlinedIcon from '@mui/icons-material/EventRepeatOutlined';
// import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
// import PhonelinkEraseIcon from '@mui/icons-material/PhonelinkErase';
// import TaskAltIcon from '@mui/icons-material/TaskAlt';

// export const CrmDataAdminQuickNumbers = ({ darkMode = false }) => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const [userlogin, setUserLogin] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [stageLeadscountarray, setStageLeadscountarray] = useState([]);
//   const [totalCustomers, setTotalCustomers] = useState(0);

//   const stagesIcons = {
//     Fresh: <NewReleasesOutlinedIcon />,
//     Follow: <PersonAddAltOutlinedIcon />,
//     'Follow Up': <HourglassEmptyOutlinedIcon />,
//     'Long Follow': <EventRepeatOutlinedIcon />,
//     Interested: <StarOutlineOutlinedIcon />,
//     'Not Interested': <DoNotDisturbOnOutlinedIcon />,
//     'No Answer': <PhonelinkEraseIcon />,
//     'No Answer 1st Call': <AccessAlarmOutlinedIcon />,
//     Meeting: <AccessAlarmOutlinedIcon />,
//     'Follow After Meeting': <HistoryOutlinedIcon />,
//     'Cancel Meeting': <DoDisturbOutlinedIcon />,
//     'Done Deal': <TaskAltIcon />,
//     Reservation: <EventAvailableOutlinedIcon />,
//     EOI: (
//       <svg
//         width="30"
//         height="36"
//         viewBox="0 0 24 24"
//         fill="none"
//         stroke="#000"
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path d="M6 2H14L20 8V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2Z" />
//         <path d="M9 13L11 15L16 10" stroke="#000" strokeWidth="1" fill="none" />
//       </svg>
//     ),
//     Transfer: <ArrowCircleLeftOutlinedIcon />,
//   };

//   useEffect(() => {
//     const user = localStorage.getItem('user');
//     if (user) {
//       setUserLogin(JSON.parse(user));
//     }
//   }, []);

//   const resAllStagesWithleadscount = useSelector((state) => state.Allusers.Stages_With_LeadsCount);

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       await dispatch(GetallStagesWithLeadsCount_For_Admin_Dashboard_Action_CRM_Data());
//     };
//     fetchData();
//   }, [dispatch]);

//   useEffect(() => {
//     if (resAllStagesWithleadscount?.data) {
//       setStageLeadscountarray(resAllStagesWithleadscount.data);
//       setTotalCustomers(resAllStagesWithleadscount.totalLeads || 0);
//       setLoading(false);
//     }
//   }, [resAllStagesWithleadscount]);

//   const handleStageClick = (stage) => {
//     localStorage.setItem('stagestorage', stage);
//     navigate(`/AllLeadsForAdminCRMDatapage?stage=${encodeURIComponent(stage)}`);
//   };

//   const handleGoToDuplicates = () => {
//     navigate('/AllLeadsForAdminCRMDatapage?duplicates=true&ignoreduplicate=true');
//   };

//   const refreshLeads = () => {
//     localStorage.removeItem('stagestorage');
//     if (userlogin?.data?.role === 'Admin') navigate('/AllLeadsForAdmin');
//     else navigate('/ALLLeadsForMarketer');
//   };

//   const refreshleadsdatacenter = () => {
//     localStorage.removeItem('stagestorage');
//     navigate('/AllLeadsForAdminCRMDatapage');
//   };

//   if (loading && stageLeadscountarray.length === 0) {
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" height="300px">
//         <CircularProgress style={{ color: '#102dff' }} />
//       </Box>
//     );
//   }

//   console.log('stageLeadscountarray', stageLeadscountarray);

//   return (
//     <div
//       style={{
//         width: '100%',
//         overflowX: 'hidden', // منع التمرير الأفقي
//         padding: '0 10px', // padding جانبي بسيط
//       }}
//       className="fade-in startpage dashboard-row"
//     >
//       <Row className="dashboard-row" style={{ marginTop: '22px' }}>
//         <Col xs={12} md={1} lg={1} className="sidebar-col"></Col>
//         <Col xs={12} md={11} lg={11} className="main-content-col">
//           {/* Breadcrumb Navigation */}
//           <div
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: '5px',
//               marginBottom: '20px',
//               flexWrap: 'wrap', // السماح بالتفاف المحتوى
//             }}
//           >
//             <div
//               onClick={refreshLeads}
//               style={{
//                 textDecoration: 'none',
//                 color: '#102dff',
//                 cursor: 'pointer',
//                 whiteSpace: 'nowrap',
//               }}
//             >
//               <span style={{ fontWeight: 'bold' }}>Leads</span>
//             </div>
//             <KeyboardDoubleArrowRightIcon style={{ fontSize: '16px' }} />
//             <div
//               onClick={refreshleadsdatacenter}
//               style={{
//                 textDecoration: 'none',
//                 color: '#102dff',
//                 cursor: 'pointer',
//                 whiteSpace: 'nowrap',
//               }}
//             >
//               <span style={{ fontWeight: 'bold' }}>Data Center Leads</span>
//             </div>
//             <KeyboardDoubleArrowRightIcon style={{ fontSize: '16px' }} />
//             <span style={{ color: '#666', whiteSpace: 'nowrap' }}>Dashboard Data Center</span>
//           </div>

//           {/* Title */}
//           <div
//             className={`section-title ${darkMode ? 'dark' : ''}`}
//             style={{
//               color: mode === 'dark' ? '#90caf9' : '#102dff',
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               marginBottom: '30px',
//             }}
//           >
//             <span style={{ fontSize: '24px', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
//               Quick Numbers For Data Center
//             </span>
//           </div>

//           {/* Cards Grid */}
//           <div
//             className="simple-cards-container"
//             style={{
//               display: 'grid',
//               gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', // تصغير minmax
//               gap: '15px',
//               width: '100%',
//               maxWidth: '100%',
//               overflow: 'hidden', // تأكيد منع التمرير
//             }}
//           >
//             {/* All Leads Card */}
//             <div
//               style={{
//                 background: mode === 'dark' ? '#0F7687' : '#fff',
//                 color: mode === 'dark' ? '#fff' : '#333',
//                 borderRadius: '8px',
//                 padding: '20px',
//                 cursor: 'pointer',
//                 boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
//                 minHeight: '140px',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 justifyContent: 'space-between',
//                 transition: 'transform 0.2s, box-shadow 0.2s',
//                 '&:hover': {
//                   transform: 'translateY(-2px)',
//                   boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
//                 },
//               }}
//               className={`simple-card ${darkMode ? 'dark' : ''}`}
//               onClick={refreshleadsdatacenter}
//             >
//               <div className="card-content">
//                 <div
//                   style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '10px',
//                     marginBottom: '10px',
//                   }}
//                 >
//                   <Person3OutlinedIcon
//                     style={{
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       fontSize: '24px',
//                     }}
//                   />
//                   <h3
//                     style={{
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       margin: 0,
//                       fontSize: '18px',
//                       fontWeight: '600',
//                     }}
//                   >
//                     All Leads
//                   </h3>
//                 </div>
//                 <p
//                   style={{
//                     color: mode === 'dark' ? '#e0e0e0' : '#666',
//                     marginBottom: '15px',
//                     fontSize: '14px',
//                   }}
//                 >
//                   Total system leads
//                 </p>
//                 <div
//                   className="card-stats"
//                   style={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     marginTop: 'auto',
//                   }}
//                 >
//                   <span
//                     style={{
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       fontSize: '28px',
//                       fontWeight: 'bold',
//                       lineHeight: '1',
//                     }}
//                   >
//                     {totalCustomers}
//                   </span>
//                   <span
//                     style={{
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       fontSize: '16px',
//                       fontWeight: 'bold',
//                       background:
//                         mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(16, 45, 255, 0.1)',
//                       padding: '4px 10px',
//                       borderRadius: '20px',
//                     }}
//                   >
//                     100%
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* Duplicate Card */}
//             {stageLeadscountarray
//               .filter((stage) => stage.stageName === 'Duplicate')
//               .map(({ stageName, leadCount, percentage }) => {
//                 const icon = stagesIcons[stageName] || <ControlPointDuplicateOutlinedIcon />;
//                 return (
//                   <div
//                     key={stageName}
//                     className={`simple-card ${darkMode ? 'dark' : ''}`}
//                     onClick={handleGoToDuplicates}
//                     style={{
//                       background: mode === 'dark' ? '#0F7687' : '#fff',
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       borderRadius: '8px',
//                       padding: '20px',
//                       cursor: 'pointer',
//                       boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
//                       minHeight: '140px',
//                       display: 'flex',
//                       flexDirection: 'column',
//                       justifyContent: 'space-between',
//                       transition: 'transform 0.2s, box-shadow 0.2s',
//                       '&:hover': {
//                         transform: 'translateY(-2px)',
//                         boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
//                       },
//                     }}
//                   >
//                     <div className="card-content">
//                       <div
//                         style={{
//                           display: 'flex',
//                           alignItems: 'center',
//                           gap: '10px',
//                           marginBottom: '10px',
//                         }}
//                       >
//                         {React.cloneElement(icon, {
//                           style: {
//                             fontSize: '24px',
//                             color: mode === 'dark' ? '#fff' : '#333',
//                           },
//                         })}
//                         <h3
//                           style={{
//                             color: mode === 'dark' ? '#fff' : '#333',
//                             margin: 0,
//                             fontSize: '18px',
//                             fontWeight: '600',
//                           }}
//                         >
//                           {stageName}
//                         </h3>
//                       </div>
//                       <p
//                         style={{
//                           color: mode === 'dark' ? '#e0e0e0' : '#666',
//                           marginBottom: '15px',
//                           fontSize: '14px',
//                         }}
//                       >
//                         Leads with multiple versions
//                       </p>
//                       <div
//                         className="card-stats"
//                         style={{
//                           display: 'flex',
//                           justifyContent: 'space-between',
//                           alignItems: 'center',
//                           marginTop: 'auto',
//                         }}
//                       >
//                         <span
//                           style={{
//                             color: mode === 'dark' ? '#fff' : '#333',
//                             fontSize: '28px',
//                             fontWeight: 'bold',
//                             lineHeight: '1',
//                           }}
//                         >
//                           {leadCount}
//                         </span>
//                         <span
//                           style={{
//                             color: mode === 'dark' ? '#fff' : '#333',
//                             fontSize: '16px',
//                             fontWeight: 'bold',
//                             background:
//                               mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(16, 45, 255, 0.1)',
//                             padding: '4px 10px',
//                             borderRadius: '20px',
//                           }}
//                         >
//                           {percentage}
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 );
//               })}

//             {/* Other Stages Cards */}
//             {stageLeadscountarray
//               .filter((stage) => stage.stageName !== 'Duplicate')
//               .map(({ stageId, stageName, leadCount, percentage }) => {
//                 const icon = stagesIcons[stageName] || <AutorenewOutlinedIcon />;
//                 return (
//                   <div
//                     key={stageId}
//                     className={`simple-card ${darkMode ? 'dark' : ''}`}
//                     onClick={() => handleStageClick(stageId)}
//                     style={{
//                       background: mode === 'dark' ? '#0F7687' : '#fff',
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       borderRadius: '8px',
//                       padding: '20px',
//                       cursor: 'pointer',
//                       boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
//                       minHeight: '140px',
//                       display: 'flex',
//                       flexDirection: 'column',
//                       justifyContent: 'space-between',
//                       transition: 'transform 0.2s, box-shadow 0.2s',
//                       '&:hover': {
//                         transform: 'translateY(-2px)',
//                         boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
//                       },
//                     }}
//                   >
//                     <div className="card-content">
//                       <div
//                         style={{
//                           display: 'flex',
//                           alignItems: 'center',
//                           gap: '10px',
//                           marginBottom: '10px',
//                         }}
//                       >
//                         {React.cloneElement(icon, {
//                           style: {
//                             fontSize: '24px',
//                             color: mode === 'dark' ? '#fff' : '#333',
//                           },
//                         })}
//                         <h3
//                           style={{
//                             color: mode === 'dark' ? '#fff' : '#333',
//                             margin: 0,
//                             fontSize: '18px',
//                             fontWeight: '600',
//                           }}
//                         >
//                           {stageName}
//                         </h3>
//                       </div>
//                       <p
//                         style={{
//                           color: mode === 'dark' ? '#e0e0e0' : '#666',
//                           marginBottom: '15px',
//                           fontSize: '14px',
//                         }}
//                       >
//                         Leads Of All System
//                       </p>
//                       <div
//                         className="card-stats"
//                         style={{
//                           display: 'flex',
//                           justifyContent: 'space-between',
//                           alignItems: 'center',
//                           marginTop: 'auto',
//                         }}
//                       >
//                         <span
//                           style={{
//                             color: mode === 'dark' ? '#fff' : '#333',
//                             fontSize: '28px',
//                             fontWeight: 'bold',
//                             lineHeight: '1',
//                           }}
//                         >
//                           {leadCount}
//                         </span>
//                         <span
//                           style={{
//                             color: mode === 'dark' ? '#fff' : '#333',
//                             fontSize: '16px',
//                             fontWeight: 'bold',
//                             background:
//                               mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(16, 45, 255, 0.1)',
//                             padding: '4px 10px',
//                             borderRadius: '20px',
//                           }}
//                         >
//                           {percentage}
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 );
//               })}
//           </div>
//         </Col>
//       </Row>

//       {/* إضافة margin-bottom بدون التسبب في scroll */}
//       <div
//         style={{
//           marginBottom: '100px',
//           height: '1px',
//           visibility: 'hidden',
//         }}
//       >
//         {/* عنصر غير مرئي لخلق مسافة في الأسفل */}
//       </div>
//     </div>
//   );
// };














// 20-5-2026
// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { useTheme, CircularProgress, Box } from '@mui/material';
// import { GetallStagesWithLeadsCount_For_Admin_Dashboard_Action_CRM_Data } from '../../Redux/Actions/UsersAction';
// import { useSidebarWidth } from '../../Utility/useSidebarWidth';

// import KeyboardDoubleArrowRightIcon         from '@mui/icons-material/KeyboardDoubleArrowRight';
// import TrendingUpIcon                       from '@mui/icons-material/TrendingUp';
// import NewReleasesOutlinedIcon              from '@mui/icons-material/NewReleasesOutlined';
// import ControlPointDuplicateOutlinedIcon    from '@mui/icons-material/ControlPointDuplicateOutlined';
// import HourglassEmptyOutlinedIcon           from '@mui/icons-material/HourglassEmptyOutlined';
// import HistoryOutlinedIcon                  from '@mui/icons-material/HistoryOutlined';
// import StarOutlineOutlinedIcon              from '@mui/icons-material/StarOutlineOutlined';
// import AccessAlarmOutlinedIcon              from '@mui/icons-material/AccessAlarmOutlined';
// import DoNotDisturbOnOutlinedIcon           from '@mui/icons-material/DoNotDisturbOnOutlined';
// import Person3OutlinedIcon                  from '@mui/icons-material/Person3Outlined';
// import AutorenewOutlinedIcon                from '@mui/icons-material/AutorenewOutlined';
// import DoDisturbOutlinedIcon                from '@mui/icons-material/DoDisturbOutlined';
// import EventAvailableOutlinedIcon           from '@mui/icons-material/EventAvailableOutlined';
// import PersonAddAltOutlinedIcon             from '@mui/icons-material/PersonAddAltOutlined';
// import EventRepeatOutlinedIcon              from '@mui/icons-material/EventRepeatOutlined';
// import ArrowCircleLeftOutlinedIcon          from '@mui/icons-material/ArrowCircleLeftOutlined';
// import PhonelinkEraseIcon                   from '@mui/icons-material/PhonelinkErase';
// import TaskAltIcon                          from '@mui/icons-material/TaskAlt';
// import Diversity3OutlinedIcon               from '@mui/icons-material/Diversity3Outlined';

// /* ── number colour per stage ─────────────────────────────────────── */
// const numberColor = (stageName) => {
//   if (!stageName) return null;
//   const n = stageName.toLowerCase();
//   if (n.includes('cancel'))         return '#C62828';
//   if (n.includes('not interested')) return '#C62828';
//   if (n.includes('pending'))        return '#B8860B';
//   if (n.includes('done deal'))      return '#1B5E20';
//   if (n.includes('reservation'))    return '#1B5E20';
//   if (n.includes('eoi'))            return '#0D47A1';
//   return null;
// };

// /* ── badge style based on percentage ────────────────────────────── */
// const badgeStyle = (pct) => {
//   if (pct >= 50) return { bg: '#EBF2FF', color: '#1A3ECF' };
//   if (pct > 0)   return { bg: '#EBF2FF', color: '#1A3ECF' };
//   return           { bg: '#F3F4F6', color: '#6B7280' };
// };

// /* ── icons map ──────────────────────────────────────────────────── */
// const stagesIcons = {
//   Fresh:                  <NewReleasesOutlinedIcon />,
//   Follow:                 <PersonAddAltOutlinedIcon />,
//   'Follow Up':            <HourglassEmptyOutlinedIcon />,
//   'Long Follow':          <EventRepeatOutlinedIcon />,
//   Interested:             <StarOutlineOutlinedIcon />,
//   'Not Interested':       <DoNotDisturbOnOutlinedIcon />,
//   'No Answer':            <PhonelinkEraseIcon />,
//   'No Answer 1st Call':   <AccessAlarmOutlinedIcon />,
//   Meeting:                <AccessAlarmOutlinedIcon />,
//   'Follow After Meeting': <HistoryOutlinedIcon />,
//   'Cancel Meeting':       <DoDisturbOutlinedIcon />,
//   'Done Deal':            <TaskAltIcon />,
//   Reservation:            <EventAvailableOutlinedIcon />,
//   EOI: (
//     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
//       strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M6 2H14L20 8V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2Z" />
//       <path d="M9 13L11 15L16 10" strokeWidth="1.5" fill="none" />
//     </svg>
//   ),
//   Transfer: <ArrowCircleLeftOutlinedIcon />,
// };

// /* ── single card ─────────────────────────────────────────────────── */
// const StatCard = ({ stageName, leadCount, onClick, pct }) => {
//   const theme   = useTheme();
//   const dark    = theme.palette.mode === 'dark';

//   const bs      = badgeStyle(pct);
//   const numCol  = numberColor(stageName) || (dark ? '#E2E8F0' : '#111827');
//   const textSec = dark ? '#94A3B8' : '#9CA3AF';
//   const cardBg  = dark ? '#1E1E2E' : '#FFFFFF';
//   const border  = dark ? 'rgba(255,255,255,0.07)' : '#E8EAF0';

//   return (
//     <div
//       onClick={onClick}
//       style={{
//         background    : cardBg,
//         border        : `1px solid ${border}`,
//         borderRadius  : 16,
//         padding       : '24px 22px 20px',
//         cursor        : 'pointer',
//         position      : 'relative',
//         transition    : 'box-shadow 0.18s, transform 0.18s',
//         display       : 'flex',
//         flexDirection : 'column',
//         justifyContent: 'space-between',
//         minHeight     : 115,
//       }}
//       onMouseEnter={(e) => {
//         e.currentTarget.style.boxShadow = '0 6px 24px rgba(0,0,0,0.08)';
//         e.currentTarget.style.transform = 'translateY(-2px)';
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.boxShadow = 'none';
//         e.currentTarget.style.transform = 'translateY(0)';
//       }}
//     >
//       <div style={{
//         position    : 'absolute',
//         top         : 16,
//         right       : 16,
//         display     : 'flex',
//         alignItems  : 'center',
//         gap         : 2,
//         fontSize    : 11,
//         fontWeight  : 600,
//         color       : bs.color,
//         background  : bs.bg,
//         borderRadius: 20,
//         padding     : '3px 8px',
//         lineHeight  : 1,
//       }}>
//         {pct > 0 && <TrendingUpIcon style={{ fontSize: 12 }} />}
//         {pct}%
//       </div>

//       <div style={{
//         fontSize     : 42,
//         fontWeight   : 800,
//         color        : numCol,
//         lineHeight   : 1,
//         fontFamily   : "'DM Sans', sans-serif",
//         letterSpacing: '-1.5px',
//       }}>
//         {typeof leadCount === 'number' ? leadCount.toLocaleString() : leadCount}
//       </div>

//       <div style={{
//         fontSize     : 11,
//         fontWeight   : 600,
//         letterSpacing: '0.09em',
//         color        : textSec,
//         marginTop    : 16,
//         textTransform: 'uppercase',
//       }}>
//         {stageName}
//       </div>
//     </div>
//   );
// };

// /* ── Pool Leads card ─────────────────────────────────────────────── */
// const PoolLeadsCard = ({ count, pct, onClick }) => {
//   const theme  = useTheme();
//   const dark   = theme.palette.mode === 'dark';
//   const cardBg = dark ? '#1E1E2E' : '#FFFFFF';

//   return (
//     <div
//       onClick={onClick}
//       style={{
//         background    : cardBg,
//         border        : `1px solid ${dark ? 'rgba(255,255,255,0.07)' : '#E8EAF0'}`,
//         borderTop     : '3px solid #F59E0B',
//         borderRadius  : 16,
//         padding       : '24px 22px 20px',
//         cursor        : 'pointer',
//         position      : 'relative',
//         transition    : 'box-shadow 0.18s, transform 0.18s',
//         display       : 'flex',
//         flexDirection : 'column',
//         justifyContent: 'space-between',
//         minHeight     : 115,
//       }}
//       onMouseEnter={(e) => {
//         e.currentTarget.style.boxShadow = '0 6px 24px rgba(245,158,11,0.15)';
//         e.currentTarget.style.transform = 'translateY(-2px)';
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.boxShadow = 'none';
//         e.currentTarget.style.transform = 'translateY(0)';
//       }}
//     >
//       {/* badge */}
//       <div style={{
//         position    : 'absolute',
//         top         : 16,
//         right       : 16,
//         display     : 'flex',
//         alignItems  : 'center',
//         gap         : 2,
//         fontSize    : 11,
//         fontWeight  : 600,
//         color       : '#B45309',
//         background  : '#FEF3C7',
//         borderRadius: 20,
//         padding     : '3px 8px',
//         lineHeight  : 1,
//       }}>
//         <TrendingUpIcon style={{ fontSize: 12 }} />
//         {pct}%
//       </div>

//       {/* big number */}
//       <div style={{
//         fontSize     : 42,
//         fontWeight   : 800,
//         color        : '#F59E0B',
//         lineHeight   : 1,
//         fontFamily   : "'DM Sans', sans-serif",
//         letterSpacing: '-1.5px',
//       }}>
//         {typeof count === 'number' ? count.toLocaleString() : count}
//       </div>

//       {/* label */}
//       <div style={{
//         fontSize     : 11,
//         fontWeight   : 600,
//         letterSpacing: '0.09em',
//         color        : '#B45309',
//         marginTop    : 16,
//         textTransform: 'uppercase',
//         display      : 'flex',
//         alignItems   : 'center',
//         gap          : 4,
//       }}>
//         <Diversity3OutlinedIcon style={{ fontSize: 14 }} />
//         Leads Pool
//       </div>
//     </div>
//   );
// };

// /* ══════════════════════════════════════════════════════════════════ */
// export const CrmDataAdminQuickNumbers = () => {
//   const dispatch     = useDispatch();
//   const navigate     = useNavigate();
//   const theme        = useTheme();
//   const dark         = theme.palette.mode === 'dark';
//   const sidebarWidth = useSidebarWidth();

//   const [userlogin,            setUserLogin]            = useState(null);
//   const [loading,              setLoading]              = useState(true);
//   const [stageLeadscountarray, setStageLeadscountarray] = useState([]);
//   const [totalCustomers,       setTotalCustomers]       = useState(0);
//   const [poolLeads,            setPoolLeads]            = useState(null); // ✅

//   useEffect(() => {
//     const u = localStorage.getItem('user');
//     if (u) setUserLogin(JSON.parse(u));
//   }, []);

//   const resAllStagesWithleadscount = useSelector(s => s.Allusers.Stages_With_LeadsCount);

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       await dispatch(GetallStagesWithLeadsCount_For_Admin_Dashboard_Action_CRM_Data());
//     };
//     fetchData();
//   }, [dispatch]);

//   useEffect(() => {
//     if (resAllStagesWithleadscount?.data) {
//       setStageLeadscountarray(resAllStagesWithleadscount.data);
//       setTotalCustomers(resAllStagesWithleadscount.totalLeads || 0);
//       setPoolLeads(resAllStagesWithleadscount.poolLeads || null); // ✅
//       setLoading(false);
//     }
//   }, [resAllStagesWithleadscount]);

//   const handleStageClick       = (id) => { localStorage.setItem('stagestorage', id); navigate(`/AllLeadsForAdminCRMDatapage?stage=${encodeURIComponent(id)}`); };
//   const handleGoToDuplicates   = () => navigate('/AllLeadsForAdminCRMDatapage?duplicates=true&ignoreduplicate=true');
//   const refreshLeads           = () => { localStorage.removeItem('stagestorage'); navigate(userlogin?.data?.role === 'Admin' ? '/AllLeadsForAdmin' : '/ALLLeadsForMarketer'); };
//   const refreshleadsdatacenter = () => { localStorage.removeItem('stagestorage'); navigate('/AllLeadsForAdminCRMDatapage'); };

//   // ✅ handler للـ Pool Leads
//   const handleGoToPoolLeads = () => {
//     if (!poolLeads?.salesId) return;
//     navigate(
//       `/AllLeadsForAdminCRMDatapage?salesId=${poolLeads.salesId}&salesName=${encodeURIComponent('No Sales')}`
//     );
//   };

//   const calcPct = (count) => {
//     if (!totalCustomers || totalCustomers === 0) return 0;
//     return Math.round((count / totalCustomers) * 100);
//   };

//   const textPri = dark ? '#E2E8F0' : '#111827';
//   const textSec = dark ? '#94A3B8' : '#9CA3AF';
//   const accent  = '#1A3ECF';

//   const duplicates  = stageLeadscountarray.filter(s => s.stageName === 'Duplicate');
//   const otherStages = stageLeadscountarray.filter(s => s.stageName !== 'Duplicate');

//   return (
//     <div
//       style={{
//         position  : 'fixed',
//         top       : '50px',
//         left      : sidebarWidth,
//         right     : 0,
//         bottom    : 0,
//         overflowY : 'auto',
//         overflowX : 'hidden',
//         transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
//         background: dark ? '#0f1117' : '#f4f6fb',
//         padding   : '28px 28px 48px',
//         fontFamily: "'DM Sans', sans-serif",
//       }}
//     >
//       {/* breadcrumb */}
//       <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, marginBottom: 20, flexWrap: 'wrap' }}>
//         <span onClick={refreshLeads}           style={{ color: accent, fontWeight: 600, cursor: 'pointer' }}>Leads</span>
//         <KeyboardDoubleArrowRightIcon style={{ fontSize: 14, color: '#9ca3af' }} />
//         <span onClick={refreshleadsdatacenter} style={{ color: accent, fontWeight: 600, cursor: 'pointer' }}>Data Center Leads</span>
//         <KeyboardDoubleArrowRightIcon style={{ fontSize: 14, color: '#9ca3af' }} />
//         <span style={{ color: '#9ca3af' }}>Dashboard Data Center</span>
//       </div>

//       {/* header */}
//       <div style={{ marginBottom: 22 }}>
//         <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: textPri }}>
//           Quick Numbers — Data Center
//         </h2>
//         <p style={{ margin: '4px 0 0', fontSize: 13, color: textSec }}>
//           Real-time engagement metrics for your portfolio
//         </p>
//       </div>

//       {/* loading */}
//       {loading && stageLeadscountarray.length === 0 ? (
//         <Box display="flex" justifyContent="center" alignItems="center" height={300}>
//           <CircularProgress style={{ color: accent }} />
//         </Box>
//       ) : (
//         <div style={{
//           display            : 'grid',
//           gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
//           gap                : 16,
//         }}>
//           {/* All Leads */}
//           <StatCard
//             stageName="All Leads"
//             leadCount={totalCustomers}
//             onClick  ={refreshleadsdatacenter}
//             pct      ={100}
//           />

//           {/* ✅ Pool Leads Card */}
//           {poolLeads && (
//             <PoolLeadsCard
//               count  ={poolLeads.count ?? 0}
//               pct    ={calcPct(poolLeads.count ?? 0)}
//               onClick={handleGoToPoolLeads}
//             />
//           )}

//           {/* Duplicate */}
//           {duplicates.map(({ stageName, leadCount }) => (
//             <StatCard
//               key      ={stageName}
//               stageName={stageName}
//               leadCount={leadCount}
//               onClick  ={handleGoToDuplicates}
//               pct      ={calcPct(leadCount)}
//             />
//           ))}

//           {/* Other stages */}
//           {otherStages.map(({ stageId, stageName, leadCount }) => (
//             <StatCard
//               key      ={stageId}
//               stageName={stageName}
//               leadCount={leadCount}
//               onClick  ={() => handleStageClick(stageId)}
//               pct      ={calcPct(leadCount)}
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };















// After 20-5-2026
// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { useTheme, CircularProgress, Box } from '@mui/material';
// import { GetallStagesWithLeadsCount_For_Admin_Dashboard_Action_CRM_Data } from '../../Redux/Actions/UsersAction';
// import { useSidebarWidth } from '../../Utility/useSidebarWidth';

// import KeyboardDoubleArrowRightIcon         from '@mui/icons-material/KeyboardDoubleArrowRight';
// import TrendingUpIcon                       from '@mui/icons-material/TrendingUp';
// import NewReleasesOutlinedIcon              from '@mui/icons-material/NewReleasesOutlined';
// import ControlPointDuplicateOutlinedIcon    from '@mui/icons-material/ControlPointDuplicateOutlined';
// import HourglassEmptyOutlinedIcon           from '@mui/icons-material/HourglassEmptyOutlined';
// import HistoryOutlinedIcon                  from '@mui/icons-material/HistoryOutlined';
// import StarOutlineOutlinedIcon              from '@mui/icons-material/StarOutlineOutlined';
// import AccessAlarmOutlinedIcon              from '@mui/icons-material/AccessAlarmOutlined';
// import DoNotDisturbOnOutlinedIcon           from '@mui/icons-material/DoNotDisturbOnOutlined';
// import Person3OutlinedIcon                  from '@mui/icons-material/Person3Outlined';
// import AutorenewOutlinedIcon                from '@mui/icons-material/AutorenewOutlined';
// import DoDisturbOutlinedIcon                from '@mui/icons-material/DoDisturbOutlined';
// import EventAvailableOutlinedIcon           from '@mui/icons-material/EventAvailableOutlined';
// import PersonAddAltOutlinedIcon             from '@mui/icons-material/PersonAddAltOutlined';
// import EventRepeatOutlinedIcon              from '@mui/icons-material/EventRepeatOutlined';
// import ArrowCircleLeftOutlinedIcon          from '@mui/icons-material/ArrowCircleLeftOutlined';
// import PhonelinkEraseIcon                   from '@mui/icons-material/PhonelinkErase';
// import TaskAltIcon                          from '@mui/icons-material/TaskAlt';
// import Diversity3OutlinedIcon               from '@mui/icons-material/Diversity3Outlined';

// /* ── الترتيب المطلوب ── */
// const STAGE_ORDER = [
//   'All Leads',
//   'Leads Pool',
//   'Duplicate',
//   'Fresh',
//   'No Answer',
//   'Follow Up',
//   'Interested',
//   'Meeting',
//   'Follow After Meeting',
//   'EOI',
//   'Done Deal',
//   'Cancel Meeting',
//   'Transfer',
//   'Not Interested',
//   'No Stage',
//   'Pending',
// ];

// /* ── number colour per stage ─────────────────────────────────────── */
// const numberColor = (stageName) => {
//   if (!stageName) return null;
//   const n = stageName.toLowerCase();
//   if (n.includes('cancel'))         return '#C62828';
//   if (n.includes('not interested')) return '#C62828';
//   if (n.includes('pending'))        return '#B8860B';
//   if (n.includes('done deal'))      return '#1B5E20';
//   if (n.includes('reservation'))    return '#1B5E20';
//   if (n.includes('eoi'))            return '#0D47A1';
//   return null;
// };

// /* ── badge style based on percentage ────────────────────────────── */
// const badgeStyle = (pct) => {
//   if (pct >= 50) return { bg: '#EBF2FF', color: '#1A3ECF' };
//   if (pct > 0)   return { bg: '#EBF2FF', color: '#1A3ECF' };
//   return           { bg: '#F3F4F6', color: '#6B7280' };
// };

// /* ── icons map ──────────────────────────────────────────────────── */
// const stagesIcons = {
//   Fresh:                  <NewReleasesOutlinedIcon />,
//   Follow:                 <PersonAddAltOutlinedIcon />,
//   'Follow Up':            <HourglassEmptyOutlinedIcon />,
//   'Long Follow':          <EventRepeatOutlinedIcon />,
//   Interested:             <StarOutlineOutlinedIcon />,
//   'Not Interested':       <DoNotDisturbOnOutlinedIcon />,
//   'No Answer':            <PhonelinkEraseIcon />,
//   'No Answer 1st Call':   <AccessAlarmOutlinedIcon />,
//   Meeting:                <AccessAlarmOutlinedIcon />,
//   'Follow After Meeting': <HistoryOutlinedIcon />,
//   'Cancel Meeting':       <DoDisturbOutlinedIcon />,
//   'Done Deal':            <TaskAltIcon />,
//   Reservation:            <EventAvailableOutlinedIcon />,
//   EOI: (
//     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
//       strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M6 2H14L20 8V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2Z" />
//       <path d="M9 13L11 15L16 10" strokeWidth="1.5" fill="none" />
//     </svg>
//   ),
//   Transfer: <ArrowCircleLeftOutlinedIcon />,
// };

// /* ── single card ─────────────────────────────────────────────────── */
// const StatCard = ({ stageName, leadCount, onClick, pct }) => {
//   const theme   = useTheme();
//   const dark    = theme.palette.mode === 'dark';

//   const bs      = badgeStyle(pct);
//   const numCol  = numberColor(stageName) || (dark ? '#E2E8F0' : '#111827');
//   const textSec = dark ? '#94A3B8' : '#9CA3AF';
//   const cardBg  = dark ? '#1E1E2E' : '#FFFFFF';
//   const border  = dark ? 'rgba(255,255,255,0.07)' : '#E8EAF0';

//   return (
//     <div
//       onClick={onClick}
//       style={{
//         background    : cardBg,
//         border        : `1px solid ${border}`,
//         borderRadius  : 16,
//         padding       : '24px 22px 20px',
//         cursor        : 'pointer',
//         position      : 'relative',
//         transition    : 'box-shadow 0.18s, transform 0.18s',
//         display       : 'flex',
//         flexDirection : 'column',
//         justifyContent: 'space-between',
//         minHeight     : 115,
//       }}
//       onMouseEnter={(e) => {
//         e.currentTarget.style.boxShadow = '0 6px 24px rgba(0,0,0,0.08)';
//         e.currentTarget.style.transform = 'translateY(-2px)';
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.boxShadow = 'none';
//         e.currentTarget.style.transform = 'translateY(0)';
//       }}
//     >
//       <div style={{
//         position    : 'absolute',
//         top         : 16,
//         right       : 16,
//         display     : 'flex',
//         alignItems  : 'center',
//         gap         : 2,
//         fontSize    : 11,
//         fontWeight  : 600,
//         color       : bs.color,
//         background  : bs.bg,
//         borderRadius: 20,
//         padding     : '3px 8px',
//         lineHeight  : 1,
//       }}>
//         {pct > 0 && <TrendingUpIcon style={{ fontSize: 12 }} />}
//         {pct}%
//       </div>

//       <div style={{
//         fontSize     : 42,
//         fontWeight   : 800,
//         color        : numCol,
//         lineHeight   : 1,
//         fontFamily   : "'DM Sans', sans-serif",
//         letterSpacing: '-1.5px',
//       }}>
//         {typeof leadCount === 'number' ? leadCount.toLocaleString() : leadCount}
//       </div>

//       <div style={{
//         fontSize     : 11,
//         fontWeight   : 600,
//         letterSpacing: '0.09em',
//         color        : textSec,
//         marginTop    : 16,
//         textTransform: 'uppercase',
//       }}>
//         {stageName}
//       </div>
//     </div>
//   );
// };

// /* ── Pool Leads card ─────────────────────────────────────────────── */
// const PoolLeadsCard = ({ count, pct, onClick }) => {
//   const theme  = useTheme();
//   const dark   = theme.palette.mode === 'dark';
//   const cardBg = dark ? '#1E1E2E' : '#FFFFFF';

//   return (
//     <div
//       onClick={onClick}
//       style={{
//         background    : cardBg,
//         border        : `1px solid ${dark ? 'rgba(255,255,255,0.07)' : '#E8EAF0'}`,
//         borderTop     : '3px solid #F59E0B',
//         borderRadius  : 16,
//         padding       : '24px 22px 20px',
//         cursor        : 'pointer',
//         position      : 'relative',
//         transition    : 'box-shadow 0.18s, transform 0.18s',
//         display       : 'flex',
//         flexDirection : 'column',
//         justifyContent: 'space-between',
//         minHeight     : 115,
//       }}
//       onMouseEnter={(e) => {
//         e.currentTarget.style.boxShadow = '0 6px 24px rgba(245,158,11,0.15)';
//         e.currentTarget.style.transform = 'translateY(-2px)';
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.boxShadow = 'none';
//         e.currentTarget.style.transform = 'translateY(0)';
//       }}
//     >
//       <div style={{
//         position    : 'absolute',
//         top         : 16,
//         right       : 16,
//         display     : 'flex',
//         alignItems  : 'center',
//         gap         : 2,
//         fontSize    : 11,
//         fontWeight  : 600,
//         color       : '#B45309',
//         background  : '#FEF3C7',
//         borderRadius: 20,
//         padding     : '3px 8px',
//         lineHeight  : 1,
//       }}>
//         <TrendingUpIcon style={{ fontSize: 12 }} />
//         {pct}%
//       </div>

//       <div style={{
//         fontSize     : 42,
//         fontWeight   : 800,
//         color        : '#F59E0B',
//         lineHeight   : 1,
//         fontFamily   : "'DM Sans', sans-serif",
//         letterSpacing: '-1.5px',
//       }}>
//         {typeof count === 'number' ? count.toLocaleString() : count}
//       </div>

//       <div style={{
//         fontSize     : 11,
//         fontWeight   : 600,
//         letterSpacing: '0.09em',
//         color        : '#B45309',
//         marginTop    : 16,
//         textTransform: 'uppercase',
//         display      : 'flex',
//         alignItems   : 'center',
//         gap          : 4,
//       }}>
//         <Diversity3OutlinedIcon style={{ fontSize: 14 }} />
//         Leads Pool
//       </div>
//     </div>
//   );
// };

// /* ══════════════════════════════════════════════════════════════════ */
// export const CrmDataAdminQuickNumbers = () => {
//   const dispatch     = useDispatch();
//   const navigate     = useNavigate();
//   const theme        = useTheme();
//   const dark         = theme.palette.mode === 'dark';
//   const sidebarWidth = useSidebarWidth();

//   const [userlogin,            setUserLogin]            = useState(null);
//   const [loading,              setLoading]              = useState(true);
//   const [stageLeadscountarray, setStageLeadscountarray] = useState([]);
//   const [totalCustomers,       setTotalCustomers]       = useState(0);
//   const [poolLeads,            setPoolLeads]            = useState(null);

//   useEffect(() => {
//     const u = localStorage.getItem('user');
//     if (u) setUserLogin(JSON.parse(u));
//   }, []);

//   const resAllStagesWithleadscount = useSelector(s => s.Allusers.Stages_With_LeadsCount);

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       await dispatch(GetallStagesWithLeadsCount_For_Admin_Dashboard_Action_CRM_Data());
//     };
//     fetchData();
//   }, [dispatch]);

//   useEffect(() => {
//     if (resAllStagesWithleadscount?.data) {
//       setStageLeadscountarray(resAllStagesWithleadscount.data);
//       setTotalCustomers(resAllStagesWithleadscount.totalLeads || 0);
//       setPoolLeads(resAllStagesWithleadscount.poolLeads || null);
//       setLoading(false);
//     }
//   }, [resAllStagesWithleadscount]);

//   const handleStageClick       = (id) => { localStorage.setItem('stagestorage', id); navigate(`/AllLeadsForAdminCRMDatapage?stage=${encodeURIComponent(id)}`); };
//   const handleGoToDuplicates   = () => navigate('/AllLeadsForAdminCRMDatapage?duplicates=true&ignoreduplicate=true');
//   const refreshLeads           = () => { localStorage.removeItem('stagestorage'); navigate(userlogin?.data?.role === 'Admin' ? '/AllLeadsForAdmin' : '/ALLLeadsForMarketer'); };
//   const refreshleadsdatacenter = () => { localStorage.removeItem('stagestorage'); navigate('/AllLeadsForAdminCRMDatapage'); };
//   const handleGoToPoolLeads    = () => {
//     if (!poolLeads?.salesId) return;
//     navigate(`/AllLeadsForAdminCRMDatapage?salesId=${poolLeads.salesId}&salesName=${encodeURIComponent('No Sales')}`);
//   };

//   const calcPct = (count) => {
//     if (!totalCustomers || totalCustomers === 0) return 0;
//     return Math.round((count / totalCustomers) * 100);
//   };

//   const textPri = dark ? '#E2E8F0' : '#111827';
//   const textSec = dark ? '#94A3B8' : '#9CA3AF';
//   const accent  = '#1A3ECF';

//   /* ── بناء كل الكروت في array واحدة ثم ترتيبها ── */
//   const allCardsRaw = [
//     /* All Leads */
//     {
//       key      : 'all-leads',
//       stageName: 'All Leads',
//       type     : 'stat',
//       leadCount: totalCustomers,
//       onClick  : refreshleadsdatacenter,
//       pct      : 100,
//     },
//     /* Pool Leads */
//     ...(poolLeads ? [{
//       key      : 'pool-leads',
//       stageName: 'Leads Pool',
//       type     : 'pool',
//       count    : poolLeads.count ?? 0,
//       onClick  : handleGoToPoolLeads,
//       pct      : calcPct(poolLeads.count ?? 0),
//     }] : []),
//     /* Duplicate */
//     ...stageLeadscountarray
//       .filter(s => s.stageName === 'Duplicate')
//       .map(({ stageName, leadCount }) => ({
//         key      : 'dup',
//         stageName,
//         type     : 'stat',
//         leadCount,
//         onClick  : handleGoToDuplicates,
//         pct      : calcPct(leadCount),
//       })),
//     /* باقي الـ stages */
//     ...stageLeadscountarray
//       .filter(s => s.stageName !== 'Duplicate')
//       .map(({ stageId, stageName, leadCount }) => ({
//         key      : stageId,
//         stageName,
//         type     : 'stat',
//         leadCount,
//         onClick  : () => handleStageClick(stageId),
//         pct      : calcPct(leadCount),
//       })),
//   ];

//   /* ترتيب حسب STAGE_ORDER */
//   const sortedCards = [...allCardsRaw].sort((a, b) => {
//     const ai = STAGE_ORDER.findIndex(
//       name => name.toLowerCase() === a.stageName.toLowerCase()
//     );
//     const bi = STAGE_ORDER.findIndex(
//       name => name.toLowerCase() === b.stageName.toLowerCase()
//     );
//     return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
//   });

//   return (
//     <div
//       style={{
//         position  : 'fixed',
//         top       : '50px',
//         left      : sidebarWidth,
//         right     : 0,
//         bottom    : 0,
//         overflowY : 'auto',
//         overflowX : 'hidden',
//         transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
//         background: dark ? '#0f1117' : '#f4f6fb',
//         padding   : '28px 28px 48px',
//         fontFamily: "'DM Sans', sans-serif",
//       }}
//     >
//       {/* breadcrumb */}
//       <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, marginBottom: 20, flexWrap: 'wrap' }}>
//         <span onClick={refreshLeads}           style={{ color: accent, fontWeight: 600, cursor: 'pointer' }}>Leads</span>
//         <KeyboardDoubleArrowRightIcon style={{ fontSize: 14, color: '#9ca3af' }} />
//         <span onClick={refreshleadsdatacenter} style={{ color: accent, fontWeight: 600, cursor: 'pointer' }}>Data Center Leads</span>
//         <KeyboardDoubleArrowRightIcon style={{ fontSize: 14, color: '#9ca3af' }} />
//         <span style={{ color: '#9ca3af' }}>Dashboard Data Center</span>
//       </div>

//       {/* header */}
//       <div style={{ marginBottom: 22 }}>
//         <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: textPri }}>
//           Quick Numbers — Data Center
//         </h2>
//         <p style={{ margin: '4px 0 0', fontSize: 13, color: textSec }}>
//           Real-time engagement metrics for your portfolio
//         </p>
//       </div>

//       {/* loading */}
//       {loading && stageLeadscountarray.length === 0 ? (
//         <Box display="flex" justifyContent="center" alignItems="center" height={300}>
//           <CircularProgress style={{ color: accent }} />
//         </Box>
//       ) : (
//         <div style={{
//           display            : 'grid',
//           gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
//           gap                : 16,
//         }}>
//           {sortedCards.map((card) =>
//             card.type === 'pool' ? (
//               <PoolLeadsCard
//                 key    ={card.key}
//                 count  ={card.count}
//                 pct    ={card.pct}
//                 onClick={card.onClick}
//               />
//             ) : (
//               <StatCard
//                 key      ={card.key}
//                 stageName={card.stageName}
//                 leadCount={card.leadCount}
//                 onClick  ={card.onClick}
//                 pct      ={card.pct}
//               />
//             )
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

























// 13-7-2026

// 13/7/2026
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme, CircularProgress, Box } from '@mui/material';
import { GetallStagesWithLeadsCount_For_Admin_Dashboard_Action_CRM_Data } from '../../Redux/Actions/UsersAction';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';

import KeyboardDoubleArrowRightIcon         from '@mui/icons-material/KeyboardDoubleArrowRight';
import TrendingUpIcon                       from '@mui/icons-material/TrendingUp';
import NewReleasesOutlinedIcon              from '@mui/icons-material/NewReleasesOutlined';
import ControlPointDuplicateOutlinedIcon    from '@mui/icons-material/ControlPointDuplicateOutlined';
import HourglassEmptyOutlinedIcon           from '@mui/icons-material/HourglassEmptyOutlined';
import HistoryOutlinedIcon                  from '@mui/icons-material/HistoryOutlined';
import StarOutlineOutlinedIcon              from '@mui/icons-material/StarOutlineOutlined';
import AccessAlarmOutlinedIcon              from '@mui/icons-material/AccessAlarmOutlined';
import DoNotDisturbOnOutlinedIcon           from '@mui/icons-material/DoNotDisturbOnOutlined';
import Person3OutlinedIcon                  from '@mui/icons-material/Person3Outlined';
import AutorenewOutlinedIcon                from '@mui/icons-material/AutorenewOutlined';
import DoDisturbOutlinedIcon                from '@mui/icons-material/DoDisturbOutlined';
import EventAvailableOutlinedIcon           from '@mui/icons-material/EventAvailableOutlined';
import PersonAddAltOutlinedIcon             from '@mui/icons-material/PersonAddAltOutlined';
import EventRepeatOutlinedIcon              from '@mui/icons-material/EventRepeatOutlined';
import ArrowCircleLeftOutlinedIcon          from '@mui/icons-material/ArrowCircleLeftOutlined';
import PhonelinkEraseIcon                   from '@mui/icons-material/PhonelinkErase';
import TaskAltIcon                          from '@mui/icons-material/TaskAlt';
import Diversity3OutlinedIcon               from '@mui/icons-material/Diversity3Outlined';
import BusinessCenterOutlinedIcon           from '@mui/icons-material/BusinessCenterOutlined'; // ✅ NEW

/* ── الترتيب المطلوب ── */
const STAGE_ORDER = [
  'All Leads',
  'Leads Pool',
  'Duplicate',
  'Fresh',
  'No Answer',
  'Follow Up',
  'Interested',
  'Meeting',
  'Follow After Meeting',
  'EOI',
  'Done Deal',
  'Cancel Meeting',
  'Transfer',
  'Not Interested',
  'No Stage',
  'Pending',
];

/* ── number colour per stage ─────────────────────────────────────── */
const numberColor = (stageName) => {
  if (!stageName) return null;
  const n = stageName.toLowerCase();
  if (n.includes('cancel'))         return '#C62828';
  if (n.includes('not interested')) return '#C62828';
  if (n.includes('pending'))        return '#B8860B';
  if (n.includes('done deal'))      return '#1B5E20';
  if (n.includes('reservation'))    return '#1B5E20';
  if (n.includes('eoi'))            return '#0D47A1';
  return null;
};

/* ── badge style based on percentage ────────────────────────────── */
const badgeStyle = (pct) => {
  if (pct >= 50) return { bg: '#EBF2FF', color: '#1A3ECF' };
  if (pct > 0)   return { bg: '#EBF2FF', color: '#1A3ECF' };
  return           { bg: '#F3F4F6', color: '#6B7280' };
};

/* ── icons map ──────────────────────────────────────────────────── */
const stagesIcons = {
  Fresh:                  <NewReleasesOutlinedIcon />,
  Follow:                 <PersonAddAltOutlinedIcon />,
  'Follow Up':            <HourglassEmptyOutlinedIcon />,
  'Long Follow':          <EventRepeatOutlinedIcon />,
  Interested:             <StarOutlineOutlinedIcon />,
  'Not Interested':       <DoNotDisturbOnOutlinedIcon />,
  'No Answer':            <PhonelinkEraseIcon />,
  'No Answer 1st Call':   <AccessAlarmOutlinedIcon />,
  Meeting:                <AccessAlarmOutlinedIcon />,
  'Follow After Meeting': <HistoryOutlinedIcon />,
  'Cancel Meeting':       <DoDisturbOutlinedIcon />,
  'Done Deal':            <TaskAltIcon />,
  Reservation:            <EventAvailableOutlinedIcon />,
  EOI: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 2H14L20 8V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2Z" />
      <path d="M9 13L11 15L16 10" strokeWidth="1.5" fill="none" />
    </svg>
  ),
  Transfer: <ArrowCircleLeftOutlinedIcon />,
};

/* ── single card ─────────────────────────────────────────────────── */
const StatCard = ({ stageName, leadCount, onClick, pct }) => {
  const theme   = useTheme();
  const dark    = theme.palette.mode === 'dark';

  const bs      = badgeStyle(pct);
  const numCol  = numberColor(stageName) || (dark ? '#E2E8F0' : '#111827');
  const textSec = dark ? '#94A3B8' : '#9CA3AF';
  const cardBg  = dark ? '#1E1E2E' : '#FFFFFF';
  const border  = dark ? 'rgba(255,255,255,0.07)' : '#E8EAF0';

  return (
    <div
      onClick={onClick}
      style={{
        background    : cardBg,
        border        : `1px solid ${border}`,
        borderRadius  : 16,
        padding       : '24px 22px 20px',
        cursor        : 'pointer',
        position      : 'relative',
        transition    : 'box-shadow 0.18s, transform 0.18s',
        display       : 'flex',
        flexDirection : 'column',
        justifyContent: 'space-between',
        minHeight     : 115,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = '0 6px 24px rgba(0,0,0,0.08)';
        e.currentTarget.style.transform = 'translateY(-2px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = 'none';
        e.currentTarget.style.transform = 'translateY(0)';
      }}
    >
      <div style={{
        position    : 'absolute',
        top         : 16,
        right       : 16,
        display     : 'flex',
        alignItems  : 'center',
        gap         : 2,
        fontSize    : 11,
        fontWeight  : 600,
        color       : bs.color,
        background  : bs.bg,
        borderRadius: 20,
        padding     : '3px 8px',
        lineHeight  : 1,
      }}>
        {pct > 0 && <TrendingUpIcon style={{ fontSize: 12 }} />}
        {pct}%
      </div>

      <div style={{
        fontSize     : 42,
        fontWeight   : 800,
        color        : numCol,
        lineHeight   : 1,
        fontFamily   : "'DM Sans', sans-serif",
        letterSpacing: '-1.5px',
      }}>
        {typeof leadCount === 'number' ? leadCount.toLocaleString() : leadCount}
      </div>

      <div style={{
        fontSize     : 11,
        fontWeight   : 600,
        letterSpacing: '0.09em',
        color        : textSec,
        marginTop    : 16,
        textTransform: 'uppercase',
      }}>
        {stageName}
      </div>
    </div>
  );
};

/* ── Pool Leads card ─────────────────────────────────────────────── */
const PoolLeadsCard = ({ count, pct, onClick }) => {
  const theme  = useTheme();
  const dark   = theme.palette.mode === 'dark';
  const cardBg = dark ? '#1E1E2E' : '#FFFFFF';

  return (
    <div
      onClick={onClick}
      style={{
        background    : cardBg,
        border        : `1px solid ${dark ? 'rgba(255,255,255,0.07)' : '#E8EAF0'}`,
        borderTop     : '3px solid #F59E0B',
        borderRadius  : 16,
        padding       : '24px 22px 20px',
        cursor        : 'pointer',
        position      : 'relative',
        transition    : 'box-shadow 0.18s, transform 0.18s',
        display       : 'flex',
        flexDirection : 'column',
        justifyContent: 'space-between',
        minHeight     : 115,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = '0 6px 24px rgba(245,158,11,0.15)';
        e.currentTarget.style.transform = 'translateY(-2px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = 'none';
        e.currentTarget.style.transform = 'translateY(0)';
      }}
    >
      <div style={{
        position    : 'absolute',
        top         : 16,
        right       : 16,
        display     : 'flex',
        alignItems  : 'center',
        gap         : 2,
        fontSize    : 11,
        fontWeight  : 600,
        color       : '#B45309',
        background  : '#FEF3C7',
        borderRadius: 20,
        padding     : '3px 8px',
        lineHeight  : 1,
      }}>
        <TrendingUpIcon style={{ fontSize: 12 }} />
        {pct}%
      </div>

      <div style={{
        fontSize     : 42,
        fontWeight   : 800,
        color        : '#F59E0B',
        lineHeight   : 1,
        fontFamily   : "'DM Sans', sans-serif",
        letterSpacing: '-1.5px',
      }}>
        {typeof count === 'number' ? count.toLocaleString() : count}
      </div>

      <div style={{
        fontSize     : 11,
        fontWeight   : 600,
        letterSpacing: '0.09em',
        color        : '#B45309',
        marginTop    : 16,
        textTransform: 'uppercase',
        display      : 'flex',
        alignItems   : 'center',
        gap          : 4,
      }}>
        <Diversity3OutlinedIcon style={{ fontSize: 14 }} />
        Leads Pool
      </div>
    </div>
  );
};

/* ✅ NEW: Generic "special" card — reused for Outsource + Outsource Pool */
const OutsourceCard = ({ count, pct, onClick, label, accentColor, accentBg, icon }) => {
  const theme  = useTheme();
  const dark   = theme.palette.mode === 'dark';
  const cardBg = dark ? '#1E1E2E' : '#FFFFFF';

  return (
    <div
      onClick={onClick}
      style={{
        background    : cardBg,
        border        : `1px solid ${dark ? 'rgba(255,255,255,0.07)' : '#E8EAF0'}`,
        borderTop     : `3px solid ${accentColor}`,
        borderRadius  : 16,
        padding       : '24px 22px 20px',
        cursor        : 'pointer',
        position      : 'relative',
        transition    : 'box-shadow 0.18s, transform 0.18s',
        display       : 'flex',
        flexDirection : 'column',
        justifyContent: 'space-between',
        minHeight     : 115,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = `0 6px 24px ${accentColor}26`;
        e.currentTarget.style.transform = 'translateY(-2px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = 'none';
        e.currentTarget.style.transform = 'translateY(0)';
      }}
    >
      <div style={{
        position    : 'absolute',
        top         : 16,
        right       : 16,
        display     : 'flex',
        alignItems  : 'center',
        gap         : 2,
        fontSize    : 11,
        fontWeight  : 600,
        color       : accentColor,
        background  : accentBg,
        borderRadius: 20,
        padding     : '3px 8px',
        lineHeight  : 1,
      }}>
        <TrendingUpIcon style={{ fontSize: 12 }} />
        {pct}%
      </div>

      <div style={{
        fontSize     : 42,
        fontWeight   : 800,
        color        : accentColor,
        lineHeight   : 1,
        fontFamily   : "'DM Sans', sans-serif",
        letterSpacing: '-1.5px',
      }}>
        {typeof count === 'number' ? count.toLocaleString() : count}
      </div>

      <div style={{
        fontSize     : 11,
        fontWeight   : 600,
        letterSpacing: '0.09em',
        color        : accentColor,
        marginTop    : 16,
        textTransform: 'uppercase',
        display      : 'flex',
        alignItems   : 'center',
        gap          : 4,
      }}>
        {icon}
        {label}
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════════════════════════════ */
export const CrmDataAdminQuickNumbers = () => {
  const dispatch     = useDispatch();
  const navigate     = useNavigate();
  const theme        = useTheme();
  const dark         = theme.palette.mode === 'dark';
  const sidebarWidth = useSidebarWidth();

  const [userlogin,            setUserLogin]            = useState(null);
  const [loading,              setLoading]              = useState(true);
  const [stageLeadscountarray, setStageLeadscountarray] = useState([]);
  const [totalCustomers,       setTotalCustomers]       = useState(0);
  const [poolLeads,            setPoolLeads]            = useState(null);
  const [leadsOutsource,       setLeadsOutsource]       = useState(null); // ✅ NEW
  const [leadsOutsourcePool,   setLeadsOutsourcePool]   = useState(null); // ✅ NEW

  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setUserLogin(JSON.parse(u));
  }, []);

  const resAllStagesWithleadscount = useSelector(s => s.Allusers.Stages_With_LeadsCount);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await dispatch(GetallStagesWithLeadsCount_For_Admin_Dashboard_Action_CRM_Data());
    };
    fetchData();
  }, [dispatch]);

  useEffect(() => {
    if (resAllStagesWithleadscount?.data) {
      setStageLeadscountarray(resAllStagesWithleadscount.data);
      setTotalCustomers(resAllStagesWithleadscount.totalLeads || 0);
      setPoolLeads(resAllStagesWithleadscount.poolLeads || null);
      // ✅ NEW: قراءة قيم الـ Outsource من الـ response
      setLeadsOutsource(
        typeof resAllStagesWithleadscount.LeadsOutsource === 'number'
          ? resAllStagesWithleadscount.LeadsOutsource
          : null
      );
      setLeadsOutsourcePool(
        typeof resAllStagesWithleadscount.Leadsoutsourcepool === 'number'
          ? resAllStagesWithleadscount.Leadsoutsourcepool
          : null
      );
      setLoading(false);
    }
  }, [resAllStagesWithleadscount]);

  const handleStageClick       = (id) => { localStorage.setItem('stagestorage', id); navigate(`/AllLeadsForAdminCRMDatapage?stage=${encodeURIComponent(id)}`); };
  const handleGoToDuplicates   = () => navigate('/AllLeadsForAdminCRMDatapage?duplicates=true&ignoreduplicate=true');
  const refreshLeads           = () => { localStorage.removeItem('stagestorage'); navigate(userlogin?.data?.role === 'Admin' ? '/AllLeadsForAdmin' : '/ALLLeadsForMarketer'); };
  const refreshleadsdatacenter = () => { localStorage.removeItem('stagestorage'); navigate('/AllLeadsForAdminCRMDatapage'); };
  const handleGoToPoolLeads    = () => {
    if (!poolLeads?.salesId) return;
    navigate(`/AllLeadsForAdminCRMDatapage?salesId=${poolLeads.salesId}&salesName=${encodeURIComponent('No Sales')}`);
  };

  // ✅ NEW: navigate handlers للكروت الجديدة
  const handleGoToOutsource     = () => navigate('/AllLeadsForAdminCRMDatapage?outsource=true');
  const handleGoToOutsourcePool = () => {
    if (!poolLeads?.salesId) return;
    navigate(`/AllLeadsForAdminCRMDatapage?outsource=true&salesId=${poolLeads.salesId}&salesName=${encodeURIComponent('No Sales')}`);
  };

  const calcPct = (count) => {
    if (!totalCustomers || totalCustomers === 0) return 0;
    return Math.round((count / totalCustomers) * 100);
  };

  const textPri = dark ? '#E2E8F0' : '#111827';
  const textSec = dark ? '#94A3B8' : '#9CA3AF';
  const accent  = '#1A3ECF';

  /* ── بناء كل الكروت في array واحدة ثم ترتيبها ── */
  const allCardsRaw = [
    /* All Leads */
    {
      key      : 'all-leads',
      stageName: 'All Leads',
      type     : 'stat',
      leadCount: totalCustomers,
      onClick  : refreshleadsdatacenter,
      pct      : 100,
    },
    /* Pool Leads */
    ...(poolLeads ? [{
      key      : 'pool-leads',
      stageName: 'Leads Pool',
      type     : 'pool',
      count    : poolLeads.count ?? 0,
      onClick  : handleGoToPoolLeads,
      pct      : calcPct(poolLeads.count ?? 0),
    }] : []),
    /* ✅ NEW: Leads Outsource */
    ...(leadsOutsource !== null ? [{
      key        : 'leads-outsource',
      type       : 'outsource',
      count      : leadsOutsource,
      onClick    : handleGoToOutsource,
      pct        : calcPct(leadsOutsource),
      label      : 'Leads Out source',
      accentColor: '#7C3AED',
      accentBg   : '#F3E8FF',
      icon       : <BusinessCenterOutlinedIcon style={{ fontSize: 14 }} />,
    }] : []),
    /* ✅ NEW: Leads Outsource Pool */
    ...(leadsOutsourcePool !== null ? [{
      key        : 'leads-outsource-pool',
      type       : 'outsource',
      count      : leadsOutsourcePool,
      onClick    : handleGoToOutsourcePool,
      pct        : calcPct(leadsOutsourcePool),
      label      : 'Leads out source pool',
      accentColor: '#0891B2',
      accentBg   : '#CFFAFE',
      icon       : <Diversity3OutlinedIcon style={{ fontSize: 14 }} />,
    }] : []),
    /* Duplicate */
    ...stageLeadscountarray
      .filter(s => s.stageName === 'Duplicate')
      .map(({ stageName, leadCount }) => ({
        key      : 'dup',
        stageName,
        type     : 'stat',
        leadCount,
        onClick  : handleGoToDuplicates,
        pct      : calcPct(leadCount),
      })),
    /* باقي الـ stages */
    ...stageLeadscountarray
      .filter(s => s.stageName !== 'Duplicate')
      .map(({ stageId, stageName, leadCount }) => ({
        key      : stageId,
        stageName,
        type     : 'stat',
        leadCount,
        onClick  : () => handleStageClick(stageId),
        pct      : calcPct(leadCount),
      })),
  ];

  /* ترتيب حسب STAGE_ORDER (الكروت الجديدة مش موجودة في الترتيب فهتفضل في آخر الليستة الأولى) */
  const sortedCards = [...allCardsRaw].sort((a, b) => {
    // الكروت من نوع outsource تتثبت في مكانها زي ما هي (تحت الـ Pool)، من غير ترتيب حسب STAGE_ORDER
    if (a.type === 'outsource' || b.type === 'outsource') return 0;

    const ai = STAGE_ORDER.findIndex(
      name => name.toLowerCase() === a.stageName.toLowerCase()
    );
    const bi = STAGE_ORDER.findIndex(
      name => name.toLowerCase() === b.stageName.toLowerCase()
    );
    return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
  });

  return (
    <div
      style={{
        position  : 'fixed',
        top       : '50px',
        left      : sidebarWidth,
        right     : 0,
        bottom    : 0,
        overflowY : 'auto',
        overflowX : 'hidden',
        transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
        background: dark ? '#0f1117' : '#f4f6fb',
        padding   : '28px 28px 48px',
        fontFamily: "'DM Sans', sans-serif",
      }}
    >
      {/* breadcrumb */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, marginBottom: 20, flexWrap: 'wrap' }}>
        <span onClick={refreshLeads}           style={{ color: accent, fontWeight: 600, cursor: 'pointer' }}>Leads</span>
        <KeyboardDoubleArrowRightIcon style={{ fontSize: 14, color: '#9ca3af' }} />
        <span onClick={refreshleadsdatacenter} style={{ color: accent, fontWeight: 600, cursor: 'pointer' }}>Data Center Leads</span>
        <KeyboardDoubleArrowRightIcon style={{ fontSize: 14, color: '#9ca3af' }} />
        <span style={{ color: '#9ca3af' }}>Dashboard Data Center</span>
      </div>

      {/* header */}
      <div style={{ marginBottom: 22 }}>
        <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: textPri }}>
          Quick Numbers — Data Center
        </h2>
        <p style={{ margin: '4px 0 0', fontSize: 13, color: textSec }}>
          Real-time engagement metrics for your portfolio
        </p>
      </div>

      {/* loading */}
      {loading && stageLeadscountarray.length === 0 ? (
        <Box display="flex" justifyContent="center" alignItems="center" height={300}>
          <CircularProgress style={{ color: accent }} />
        </Box>
      ) : (
        <div style={{
          display            : 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
          gap                : 16,
        }}>
          {sortedCards.map((card) =>
            card.type === 'pool' ? (
              <PoolLeadsCard
                key    ={card.key}
                count  ={card.count}
                pct    ={card.pct}
                onClick={card.onClick}
              />
            ) : card.type === 'outsource' ? (
              <OutsourceCard
                key        ={card.key}
                count      ={card.count}
                pct        ={card.pct}
                onClick    ={card.onClick}
                label      ={card.label}
                accentColor={card.accentColor}
                accentBg   ={card.accentBg}
                icon       ={card.icon}
              />
            ) : (
              <StatCard
                key      ={card.key}
                stageName={card.stageName}
                leadCount={card.leadCount}
                onClick  ={card.onClick}
                pct      ={card.pct}
              />
            )
          )}
        </div>
      )}
    </div>
  );
};
